<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="informComplementaire.non"

	[label]="step5.getspan26"
	[type]="'radio'"
	[rule]="''"
	[radios]="[
		{
			label: step5.getoui,
			value: 'Oui'
		},
		{
			label: step5.getnon,
			value: 'Non'
		}
	]"
	[name]="getUid() + '_SepAtt_non'"
>
</app-form-input>

<!---->

<app-oui-type-oui-non-inform-complementaire
	[uid]="getUid()"
	[parentForm]="parentForm"
	*ngIf="isInformComplementaireOui()"
	[disabled]="disabled"
	[oui]="informComplementaire.oui"
></app-oui-type-oui-non-inform-complementaire>

<!---->

<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="informComplementaire.autresInformComplementaire"

	[label]="step5.autresInformComplementaire"
	[type]="'text'"
	[rule]="'minSize_1|maxSize_4000'"
	[name]="getUid() + '_SepAtt_autresInformComplementaire'"
>
</app-form-input>
